<div #chartContainer class="jepto-bar-chart-container"></div>
